const rawEnv = (import.meta as any)?.env || {};

const isDev = Boolean(rawEnv.DEV ?? rawEnv.MODE === 'development');

const resolveBaseUrl = (value: string | undefined, fallback: string) => {
  const raw = value?.trim() || '';
  const candidate = raw.length > 0 ? raw : fallback;
  const isAbsolute = /^https?:\/\//i.test(candidate);

  // Allow absolute URLs if explicitly set via environment variable
  // This allows hitting the API directly instead of using the proxy
  if (isAbsolute && raw.length > 0) {
    return candidate;
  }

  // Otherwise use the fallback (relative path for proxy)
  return fallback;
};

// Add CORS configuration
export const API_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    // Add CORS headers if needed
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  },
  // Add credentials if needed
  credentials: 'include' as const,
};

// Replace hardcoded IP with environment variable or domain
//export const API_BASE_URL = rawEnv.VITE_API_URL || 'http://localhost:3001/api';

export const API_BASE_URL = resolveBaseUrl(
  rawEnv.VITE_API_URL,
  '/api'
);

export const ADMIN_API_BASE_URL = resolveBaseUrl(
  rawEnv.VITE_ADMIN_API_BASE_URL,
  '/admin-api'
);

export const PRICING_API_BASE_URL = resolveBaseUrl(
  rawEnv.VITE_PRICING_API_BASE_URL,
  '/api'
);

export const RIDER_API_BASE_URL = resolveBaseUrl(
  rawEnv.VITE_RIDER_API_BASE_URL,
  '/rider-api'
);
